import React from "react";
import PropTypes from "prop-types";

const euro = (n) => `€${Math.round(Number(n) || 0)}`;

// CleanupSection lists the per-type sources a whole-scope source covers and lets
// the user choose which to archive/narrow. Selection is owned by the parent and
// applied on save. Renders nothing when there is nothing to tidy up.
const CleanupSection = ({ plan, selected, onToggle }) => {
  const covered = (plan && plan.covered) || [];
  if (covered.length === 0) return null;
  const selectedCount = covered.filter((c) => selected.includes(c.sourceId)).length;

  return (
    <div className="border-t border-border pt-3 mt-3">
      <p className="text-xs font-medium uppercase tracking-wide text-text-2 mb-1">
        Tidy up · {covered.length} per-type {covered.length === 1 ? "source" : "sources"} in this scope
      </p>
      <p className="text-[11px] text-text-3 mb-2">
        Now covered by this whole-scope source. Safe ones are pre-selected; applied when you save.
      </p>
      <ul className="space-y-1">
        {covered.map((c) => {
          const isSel = selected.includes(c.sourceId);
          const owners = (c.owners || []).map((o) => o.ownerName).filter(Boolean).join(", ");
          return (
            <li key={c.sourceId} className="text-xs">
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="checkbox" checked={isSel} onChange={() => onToggle(c.sourceId)} />
                <span className="flex-1 truncate">
                  {c.displayName}
                  {c.ownerMatch === "differs" && owners ? (
                    <span className="ml-1 rounded-full bg-warning-soft px-1.5 py-0.5 text-[10px] text-warning">owner: {owners}</span>
                  ) : null}
                </span>
                <span className="tabular-nums text-text-2">{euro(c.monthlyCost)}/mo</span>
                <span className={`font-medium ${c.action === "narrow" ? "text-primary" : "text-success"}`}>
                  {c.action === "narrow" ? "Narrow" : "Archive"}
                </span>
              </label>
              {c.action === "narrow" && c.narrowScopeValue ? (
                <div className="pl-6 text-[10px] text-text-3">Removes only {c.narrowScopeValue} — kept for its other scopes.</div>
              ) : null}
              {c.needsConfirm && !isSel ? (
                <div className="pl-6 text-[10px] text-warning">⚠ Different owner — tick to confirm; archiving reassigns this cost.</div>
              ) : null}
            </li>
          );
        })}
      </ul>
      <p className="mt-2 text-[11px] text-text-2">{selectedCount} selected · applied when you save</p>
    </div>
  );
};

CleanupSection.propTypes = {
  plan: PropTypes.shape({ covered: PropTypes.array }),
  selected: PropTypes.arrayOf(PropTypes.number).isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default CleanupSection;
